import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const DialogChangePass = (props) => {

    const { statusdialog } = props;
    const navigate = useNavigate();
    const {t} = useTranslation();

    const openDialog = statusdialog;
    const titleDialog = t('error');
    const contentDialog = t('passwordChangeError');
    const styleDialog = 'error';

    const handleCloseDialog = () => {
        //setOpenDialog(false);
        navigate('/clientarea/account/', { replace: true });
    };

    return (

        <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle variant="dialogTitle-nk" id="alert-dialog-title" color={styleDialog}>
                {titleDialog}
            </DialogTitle>
            <DialogContent>
                <Typography color={styleDialog}>{contentDialog}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog} autoFocus variant='outlined' size="small">
                    {t('understood')}
                </Button>
            </DialogActions>

        </Dialog>

    );
}

export default DialogChangePass;